import React from "react";
import { TextInputProps, TextInput } from "../../inputs/TextInput";
import { FormField, formFieldValidationHelper } from "../FormField";

type TextFieldProps = Omit<TextInputProps, 'inErrorState' | 'onChange'> & {
    label?:string,
    infoMessage?:string,
    errorMessage?:string,
    reserveMessageSpace?:boolean,
    validator?:(value:string) => { valid:true } | {valid:false, errorMessage:string},
    onChange?:(value:string, isValid:boolean)=>void
};

export function TextField(props:TextFieldProps)
{
    const validation = formFieldValidationHelper(props.value, props.infoMessage, props.errorMessage, props.validator);

    function handleChange(value:string)
    {
        props.onChange?.(value, !validation.inErrorState);
    }

    return (

        <FormField 
            reserveMessageSpace={props.reserveMessageSpace}
            label={props.label} 
            inputComponent={
                <TextInput {...props} inErrorState={validation.inErrorState} onChange={handleChange} />
            }
            inErrorState={validation.inErrorState}
            message={validation.message}
        />
    )
}